import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = { remaining: Number }

  connect() {
    if (this.hasRemainingValue) {
      this.startTimer(this.remainingValue)
    }
  }

  disconnect() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  }

  startTimer(seconds) {
    this.updateDisplay(seconds)

    this.timerInterval = setInterval(() => {
      seconds -= 1

      if (seconds <= 0) {
        clearInterval(this.timerInterval)
        this.handleTimeUp()
        return
      }

      this.updateDisplay(seconds)
    }, 1000)
  }

  updateDisplay(seconds) {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = Math.floor(seconds % 60)

    let display = ""
    if (hours > 0) {
      display = `${hours}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
    } else {
      display = `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
    }

    // Update all display targets (mobile and desktop)
    this.displayTargets.forEach(target => {
      target.textContent = display

      // Add visual warning when time is running low
      if (seconds < 300) { // Less than 5 minutes
        target.classList.add('text-red-600')

        if (seconds < 60) { // Less than 1 minute
          target.classList.add('animate-pulse')
        }
      }
    })
  }

  handleTimeUp() {
    // Update all display targets
    this.displayTargets.forEach(target => {
      target.textContent = "00:00"
      target.classList.add('text-red-600', 'font-bold')
    })

    // Show alert
    alert("Time's up! Your exam is being submitted automatically.")

    // Submit the exam
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.element.dataset.submitUrl

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    // Add method override for POST
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'post'
    form.appendChild(methodInput)

    document.body.appendChild(form)
    form.submit()
  }
}